import { isEmpty } from "lodash";

/**
 * Checks if the argument has a value. There's a value if it is not
 * null, undefined, empty string "", empty array [], empty object {}, and other
 * empty types.
 */
export function isPresent(value: unknown): boolean {
  if (value == null) return false;
  if (typeof value === "string") return value.trim() !== "";
  if (typeof value === "number") return !isNaN(value);
  if (typeof value === "boolean") return true;
  if (value instanceof Date) return true;

  return !isEmpty(value);
}

export function isBlank(value: unknown): boolean {
  return !isPresent(value);
}
